/**
 * Staleness timeout for TanStack's `useQuery` to refetch data, in milliseconds.
 */
export const STALE_QUERY_TIMEOUT_MSEC = 30_000;
